import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchLoanProducts,
  fetchLoanProductsSuccess,
  fetchLoanProductsFailure,
} from "../slices/loanProductSlice";

function* fetchLoanProductsSaga() {
  try {
    const response = yield call(
      fetch,
      `${process.env.REACT_APP_API_URL}/v1/loans`,
    );
    const data = yield response.json();

    if (data.success) {
      yield put(fetchLoanProductsSuccess(data.data.data)); // ✅ raw data
    } else {
      yield put(fetchLoanProductsFailure("Failed to fetch products"));
    }
  } catch (error) {
    yield put(
      fetchLoanProductsFailure("Error fetching products: " + error.message),
    );
  }
}

export function* watchLoanProducts() {
  yield takeLatest(fetchLoanProducts.type, fetchLoanProductsSaga);
}
